(function () {
  // Dawn's <deferred-media> (the wrapper around any video in the main
  // product gallery) normally waits for a click on its own play-button
  // overlay before it even loads the <video> tag, let alone plays it —
  // loadContent() is what does both. Calling that ourselves once a
  // slide is the one actually centered on screen reproduces a normal
  // click without requiring one.
  function playSlide(slide) {
    var deferredMedia = slide.querySelector('deferred-media');
    if (!deferredMedia) return;

    if (!deferredMedia.hasAttribute('loaded') && typeof deferredMedia.loadContent === 'function') {
      deferredMedia.loadContent(false);
    }

    // Belt-and-suspenders: loadContent()'s own internal .play() call
    // only fires the instant content is first loaded, and can be
    // silently rejected by the browser's autoplay policy either way.
    // Explicitly (re)playing whatever <video> is actually in there —
    // whether just loaded this instant or already loaded from
    // swiping back to this slide earlier — covers both cases.
    window.setTimeout(function () {
      var video = deferredMedia.querySelector('video');
      if (!video) return;
      video.muted = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          /* Autoplay blocked — the video still has visible controls
             so a visitor can start it manually. */
        });
      }
    }, 50);
  }

  // Plain scroll + elementFromPoint instead of Dawn's own "slideChanged"
  // event or an IntersectionObserver threshold — both depend on how
  // this particular "peek" (grid--peek) mobile layout computes partial
  // visibility, which wasn't reliably triggering either. Checking what
  // element is physically centered in the gallery a moment after
  // scrolling stops is about as close to "what the visitor is actually
  // looking at" as this can get without those layers in between.
  function initGallery(slider) {
    var scrollContainer = slider.querySelector('ul[id^="Slider-"]');
    if (!scrollContainer) return;

    var debounceTimer;

    function checkCenteredSlide() {
      var rect = scrollContainer.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return;
      var centerX = rect.left + rect.width / 2;
      var centerY = rect.top + rect.height / 2;
      var elementAtCenter = document.elementFromPoint(centerX, centerY);
      if (!elementAtCenter) return;
      var slide = elementAtCenter.closest('[id^="Slide-"]');
      if (!slide) return;
      playSlide(slide);
    }

    scrollContainer.addEventListener(
      'scroll',
      function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(checkCenteredSlide, 150);
      },
      { passive: true }
    );

    // Also check once on load, in case a video happens to be the
    // first/only slide already centered without any scrolling.
    window.setTimeout(checkCenteredSlide, 500);
  }

  function init() {
    document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
